/* @jsx h */
import { defineComponent, h } from "vue";

import { MenuProvider } from "@app/vue/providers/index";
import { RouterView } from "vue-router";

export const ShopPage = defineComponent({
  setup() {
    return () => {
      return (
        <MenuProvider render={() => <RouterView />}>
          <RouterView />
        </MenuProvider>
      );
    };
  },
});
